var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0_390_134)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_390_134",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_390_134",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_390_134",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEU0lEQVR4nO2cW6hVRRjHf3Y9QTexeihEsKOV0OUlKAiRivCh4giVBQWV5KFIqQez0kgKIqJACIouEF2gNCKiC12oKOhC5EsYCWlZStCFhALNLCcGvgOb0561Zu+z95rZs/4/+B7Xmm99v732rDUza0AIIYQQQgghhBBCCCGEEEKIEeZI4FLgceAt4MsBxufAG8C9wNmpL3QUuB74EXANxfvAotQXnSNjwPMNinAdsRe4KnUBcmIW8FIiGc7iH+Dy1IXIhVsTy3AWe4CTaTnHAr9mIMNZPEXLubGiOH8DzwF3AWsHFPcBn1W0uQ94sKG40/qu2WTEqxWFOXeIfdbDGdyNU3EA2AQsIAO2BpJ8ZMjtHg78nIGMzthv/xhJCfUfVzfQ9usZSOgWt5OQPYGkJhpo+54Mih96BL+QFgo5HvguAwHd4ivgUFomZErKeuBFYHOD8RrwQ40UP57XOiEpmWX9RUjI0ymSarOQKTYFarCFBEgI3BAQ8pOEpGEiIMT/WIu5QxYD9wOPArcBp5AvRQuZA7wbGIpJ+sLVRiFj1hG6ishRSrFC1kW8cP0FzCUvihTin+l3Rb4FbyAvihQyL1KGA94jL4oUck4PQrb0mauf3r0GWBkZ1wHz2ypkbg9C3ukjTz9Z9kcPbXTOcVzWRiGenZFFWt/HuWeyKubTtgq5I6I4+/pcWfLCDIR83FYhR9hSUVcRt/SZ55nAL33I+DNisqlYIZ7jbK6hW2EmBzB3shS4MjJ833FSxHmLFtLZCd8NPATcFFmYVLRCyCghIZlRrJATgRXAE8AntuZrh70IvmmrFi8CDiEvihNyhi0c2B/55LMTWGNPZTlQjBBf0Ad6EOGmxTc2kRXLOHBzD+uIVwFntUWIf7z9qE8Rbtq6Wv83V8die6nsZ9Hb8tKFHAa8PQAZzuLfiPGmzTM4/xelC1kzQBmu4+L99G+IZ2Zw7g9KFuLfln8fghBnnyiEWNDnx6i/AeeVLOTaIclw9nmCn3kMcZQV9+LIuAA4JqIGIy1kwxCFOLsDm2akhSy1TngYMrbW3CHDYqSFYDswrOhhKnVlRCy3R+kUjLyQ0piQkLyQkMyQkMyQkMyQkMyQkMwoTsjptieKH1V9BVhC8yyxtn0OzwKnjaqQ0EDhssjjL7ENyDqPPQispjlWW5udOey13GJYFqiBr03jbA8k41chxnygs7viO5BTG8h/3NrqlsNuy7GOtYHjvyUBHwaS8TssHB0xi1c1NrWqobujKoe6KWI/Gvx9xX6QjbOuZrDvCmChLeufHpM1xdgYOG6QsbEmh8nAcQvt2kK7ITnbJ6xxxm1eu+qi2hgHGvrL7cqTGRTAZRaPkXjfxa8zKILLJLYlmij735z1jgyK4RLHdvsbz4IT7OXKtTAOAi/XrHxJxvnWr8R+5jzKscvWItetTMmGMfvkeX5hMS/ypVEIIYQQQgghhBBCCCGEEEIIIYQQgmL5Dw4McfhX9xy3AAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro);
export default __webpack_public_path__ + "static/media/Pro.7a18496365ff635512c2e7c96bf453ea.svg";
export { ForwardRef as ReactComponent };